/**
 * @flow
 * @relayHash 4b23a244a317c10030d4c3f435f86ee2
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateInvoiceInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  recipient_first_name?: ?string,
  recipient_last_name?: ?string,
  recipient_company_name?: ?string,
  recipient_phone?: ?string,
  recipient_email?: ?string,
  recipient_address?: ?string,
};
export type Recipient_updateInvoiceMutationVariables = {|
  input: UpdateInvoiceInput
|};
export type Recipient_updateInvoiceMutationResponse = {|
  +updateInvoice: ?{|
    +invoice: ?{|
      +id: string,
      +recipient_first_name: ?string,
      +recipient_last_name: ?string,
      +recipient_company_name: ?string,
      +recipient_email: ?string,
      +recipient_phone: ?string,
      +recipient_address: ?string,
    |}
  |}
|};
export type Recipient_updateInvoiceMutation = {|
  variables: Recipient_updateInvoiceMutationVariables,
  response: Recipient_updateInvoiceMutationResponse,
|};
*/


/*
mutation Recipient_updateInvoiceMutation(
  $input: UpdateInvoiceInput!
) {
  updateInvoice(input: $input) {
    invoice {
      id
      recipient_first_name
      recipient_last_name
      recipient_company_name
      recipient_email
      recipient_phone
      recipient_address
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateInvoiceInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateInvoice",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "UpdateInvoiceInput!"
      }
    ],
    "concreteType": "UpdateInvoicePayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "invoice",
        "storageKey": null,
        "args": null,
        "concreteType": "Invoice",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_first_name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_last_name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_company_name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_email",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_phone",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "recipient_address",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "Recipient_updateInvoiceMutation",
  "id": null,
  "text": "mutation Recipient_updateInvoiceMutation(\n  $input: UpdateInvoiceInput!\n) {\n  updateInvoice(input: $input) {\n    invoice {\n      id\n      recipient_first_name\n      recipient_last_name\n      recipient_company_name\n      recipient_email\n      recipient_phone\n      recipient_address\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "Recipient_updateInvoiceMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "Recipient_updateInvoiceMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8328e445242249f37ed99e911cb0b6bf';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/Invoice/__generated__/Recipient_updateInvoiceMutation.graphql.js